import { render, staticRenderFns } from "./SettingsChangePassword.vue?vue&type=template&id=3749fcb0&scoped=true&"
import script from "./SettingsChangePassword.vue?vue&type=script&lang=js&"
export * from "./SettingsChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./SettingsChangePassword.vue?vue&type=style&index=0&id=3749fcb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3749fcb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3749fcb0')) {
      api.createRecord('3749fcb0', component.options)
    } else {
      api.reload('3749fcb0', component.options)
    }
    module.hot.accept("./SettingsChangePassword.vue?vue&type=template&id=3749fcb0&scoped=true&", function () {
      api.rerender('3749fcb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/SettingsChangePassword.vue"
export default component.exports